/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Frequency } from './models/weather';
export const TXM_KVS = ['33', '34.5', '69', '115', '132', '138', '161', '230', '345', '500'];
export var PlantConfiguration;
(function (PlantConfiguration) {
    PlantConfiguration["PV"] = "PV";
    PlantConfiguration["BESS"] = "BESS";
    PlantConfiguration["H2"] = "H2";
    PlantConfiguration["WIND"] = "WIND";
})(PlantConfiguration || (PlantConfiguration = {}));
export const fullMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const monthNames = fullMonthNames.map((month) => month.slice(0, 3));
export const daysPerMonth = {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
};
export const unitConvert = {
    1: '',
    1e3: 'k',
    1e6: 'M',
    1e9: 'G',
};
export const SF_MULTI_SELECT_SEPARATOR = ';';
export var WeatherDataSource;
(function (WeatherDataSource) {
    WeatherDataSource["SolarAnywhere_CPR"] = "SolarAnywhere-CPR";
    WeatherDataSource["Solargis"] = "Solargis";
    WeatherDataSource["ThreeTier_Vaisala"] = "3Tier-Vaisala";
    WeatherDataSource["MeteoNorm"] = "MeteoNorm";
    WeatherDataSource["NREL_NSRDB"] = "NREL-NSRDB";
    WeatherDataSource["BrightNight"] = "BrightNight";
})(WeatherDataSource || (WeatherDataSource = {}));
export const mappingWeatherFrequency = {
    [Frequency.Hourly]: 'Hourly',
    [Frequency.OneMinute]: '1min',
    [Frequency.FiveMinutes]: '5min',
    [Frequency.TenMinutes]: '10min',
    [Frequency.FifteenMinutes]: '15min',
    [Frequency.ThirtyMinutes]: '30min',
};
//# sourceMappingURL=data.js.map